module.exports = __webpack_public_path__ + "assets/img/thumb-Lokyata-Landing-Page-+-Website.1e7bb72c.jpg";